import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutDemoDateTimeDialog extends Layout {
}
